import type { ChartDataset, ChartOptions } from 'chart.js';

export const MONTHS_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const barChatDataset: ChartDataset = {
  type: 'bar' as const,
  label: 'Forecast',
  borderColor: '#DDE9F0',
  backgroundColor: '#DDE9F0',
  borderWidth: 2,
  borderRadius: 6,
  barThickness: 46,
  data: [],
};

export const lineDataset: ChartDataset<'line'> = {
  type: 'line' as const,
  label: 'Actual',
  borderColor: '#99FF00',
  backgroundColor: '#99FF00',
  borderWidth: 2,
  fill: false,
  pointBackgroundColor: '#FFFFFF',
  pointRadius: 5,
  pointHoverRadius: 6,
  pointBorderWidth: 2,
  pointHoverBorderWidth: 2,
  tension: 0.4,
  data: [],
};

export const options: ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      grid: {
        color: '#DFEBF1',
      },
      border: {
        display: false,
      },
      ticks: {
        font: {
          size: 13,
          family: 'Inter, sans-serif',
        },
        color: '#9F9F9F',
        count: 9,
      },
    },
    x: {
      border: {
        display: false,
      },
      ticks: {
        font: {
          size: 14,
          family: 'Inter, sans-serif',
        },
        color: '#9F9F9F',
      },
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      position: 'top' as const,
      align: 'end' as const,
      labels: {
        boxHeight: 14,
        boxWidth: 4,
        borderRadius: 1,
        useBorderRadius: true,
        font: {
          size: 16,
          family: 'Inter, sans-serif',
          weight: '400',
        },
      },
    },
  },
};